/* Le voile est clair et chaud (AGENTS, regle 2) : on range une chose, on ne dramatise pas. */
.supprimer-voile {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: var(--voile);
}

.supprimer {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 51;
  transform: translate(-50%, -50%);
  width: min(480px, calc(100vw - 32px));
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  padding: 28px 30px 24px;
  background: var(--surface);
  border-radius: var(--arrondi-panneau);
  box-shadow: var(--ombre-dialogue);
}

/* Ouverte depuis l'inventaire (ticket 18 de retours-testeurs) : au-dessus de lui, voile
   compris, pour qu'un clic a cote referme la confirmation et pas l'inventaire. */
.supprimer-voile.supprimer--au-dessus {
  z-index: 52;
}
.supprimer.supprimer--au-dessus {
  z-index: 53;
}

.supprimer h2 {
  font-size: var(--t-nom);
  font-weight: 600;
  letter-spacing: var(--serre);
  overflow-wrap: anywhere;
}

.supprimer-emporte {
  margin-top: 14px;
  font-size: var(--t-lecture);
  color: var(--encre);
}

.supprimer-impasse {
  margin-top: 10px;
  font-size: var(--t-mention);
  color: var(--encre-douce);
}

.supprimer-refus {
  margin-top: 14px;
}

.supprimer-gestes {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
}
